import { useEffect, useState } from "react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Autoplay, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import IMAGES from "../../../constant/IMAGES";
import useResponsive from "../../../hooks/useResponsive";
import TextHeader from "../../TextHeader";
import AOS from "aos";
import "aos/dist/aos.css";
import { detectAndHandleRedirect } from "../Section1";

const items = [
  {
    title: "La kinh",
    des: "La kinh là một công cụ được sử dụng để xác định phương hướng địa lý ở một khu vực nhất định một cách chính xác. Thông qua việc sử dụng cảm biến trong điện thoại thông minh hoặc thiết bị điện tử khác, ứng dụng này cung cấp thông tin về hướng cụ thể của một địa điểm dựa trên hệ quy chiếu của bản đồ.",
    img: IMAGES.laKinhImg,
  },
  {
    title: "Xem Phong thủy",
    des: "Luận đoán phong thủy là quá trình luận đoán và phân tích các yếu tố về không gian và môi trường để đưa ra các khuyến nghị về cách sắp xếp và thiết kế nhà cửa hoặc công trình nhằm tối ưu hóa sự cân bằng và hòa hợp với năng lượng. Trong ứng dụng Xhero, tính năng xem phong thủy được cung cấp thông qua module chuyên biệt.",
    img: IMAGES.xemPhongThuy,
  },
  {
    title: "Xem ngày",
    des: "Tính năng xem ngày tốt trên ứng dụng Xhero cung cấp cho người dùng thông tin về các ngày may mắn và thích hợp để thực hiện các công việc quan trọng. Đặc biệt, thông tin về các sự kiện sắp diễn ra trong 30 ngày tới cũng được liệt kê sẵn để người dùng tham khảo. Khi chọn xem ngày, Xhero sẽ hiển thị 7 mục chính của các công việc, mỗi mục chứa nhiều công việc chi tiết mà người dùng muốn xem.",
    img: IMAGES.xemNgay,
  },
  {
    title: "Gia phả",
    des: "Gia phả là bản ghi chi tiết về tên, tuổi, vai trò và công đức của tổ tiên trong một gia đình hoặc dòng họ. Ứng dụng Gia phả giúp người dùng dễ dàng tạo và quản lý thông tin phả hệ, hiểu rõ hơn về nguồn gốc và phát triển của gia đình. Với chức năng tạo và quản lý thư mục danh sách phả hệ cũng như sơ đồ nhánh cây gia phả, người dùng có thể hiểu rõ hơn về nguồn gốc, tạo ra một kết nối mạnh mẽ với dòng dõi của mình.",
    img: IMAGES.giaPha,
  },
  {
    title: "Kết nối chuyên gia",
    des: "Nâng tầm cuộc sống với Dịch vụ Tư vấn Phong Thủy thông minh trên Xhero. Xhero mang đến Dịch vụ Tư vấn Phong Thủy thông minh, kết nối bạn với đội ngũ chuyên gia dày dặn kinh nghiệm, được sàng lọc kỹ lưỡng, đảm bảo chất lượng và sự uy tín tuyệt đối. Trải nghiệm Dịch vụ tiện lợi nhanh chóng, đội ngũ chăm sóc khách hàng tận tâm, chu đáo.",
    img: IMAGES.ketNoiCG,
  },
  {
    title: "X-Check",
    des: "X-Check được thiết kế để đảm bảo rằng mỗi thông tin và sản phẩm mà người dùng tiếp cận đều đạt chuẩn cao nhất trong thời đại thông tin bùng nổ và hàng giả tràn lan. Chức năng này hoạt động trên hai bình diện: Xác minh chuyên gia phong thủy, kiểm tra sản phẩm chính hãng.",
    img: IMAGES.Xcheck,
  },
  {
    title: "Sự kiện cá nhân",
    des: "Trong guồng quay vội vã của cuộc sống hiện đại, việc quản lý thời gian hiệu quả trở nên quan trọng hơn bao giờ hết. Với chức năng Sự kiện cá nhân, người dùng sẽ không bao giờ bỏ lỡ bất kỳ cuộc hẹn quan trọng nào: Dễ dàng tạo nhắc nhở, liên kết với Google Map giúp người dùng định vị và di chuyển đến địa điểm một cách dễ dàng, chính xác, không mất nhiều thời gian.",
    img: IMAGES.suKienCaNhan,
  },
];

const SectionFeature1 = () => {
  const { isTabletOrLaptop } = useResponsive();
  const [activeIndex, setActiveIndex] = useState(0);
  const [showContent, setShowContent] = useState(false);
  useEffect(() => {
    setShowContent(true);
  }, [activeIndex]);

  const handleNext = (prev: number) => {
    setShowContent(false);
    setTimeout(() => {
      setActiveIndex(prev + 1);
    }, 500);
  };
  const handlePrev = (prev: number) => {
    setShowContent(false);
    setTimeout(() => {
      setActiveIndex(prev - 1);
    }, 500);
  };

  const renderBullet = (index: any, className: any) => {
    return `<div class="${className}"></div>`;
  };

  return (
    <div
      id="tinh-nang-noi-bat"
      className="flex flex-col gap-[40px] xl:scroll-m-52 scroll-m-32"
      data-aos="fade-up"
    >
      <TextHeader text="TÍNH NĂNG NỔI BẬT" />
      <div className="xl:bg-feature1Bg flex xl:flex-row flex-col-reverse gap-[10px] md:gap-10 xl:gap-14 items-start justify-between bg-[length:100%_100%] h-fit w-full bg-no-repeat md:px-[10%] md:py-[5%] xl:pb-[8%] relative">
        <div
          className="xl:max-w-[43%] w-full flex flex-col items-start gap-[10px] md:gap-8"
          data-aos="fade-up"
          data-aos-offset="100"
          data-aos-once="true"
        >
          <img
            src={IMAGES.logoNgang}
            alt="ngang"
            className="-translate-x-1/2 xl:block hidden"
          />
          <div className="flex justify-between items-center w-full h-[60px] md:h-unset">
            <p
              className={`text-[#FAFAFA] font-bold text-xl md:text-4xl ${
                showContent ? "opacity-100" : "opacity-0"
              } transition-all duration-700 `}
            >
              {items[activeIndex].title}
            </p>
          </div>
          <p className="bg-borderFeature1 text-justify text-white text-sm md:text-base 2xl:text-xl bg-no-repeat bg-center bg-[length:100%_100%] p-8 xl:min-h-[280px] 2xl:min-h-[320px] transation-all duration-300">
            <span
              className={`${
                showContent ? "opacity-100" : " opacity-0"
              } transition-all duration-700`}
            >
              {items[activeIndex].des}
            </span>
          </p>
          <div className="flex items-center gap-[20px] text-goldGradient text-sm md:text-xl">
            <img src={IMAGES.qrApp} alt="qr" className="w-16 md:w-[106px] cursor-pointer"
              onClick={() => detectAndHandleRedirect()} />
            Quét QR code để trải nghiệm các tính năng từ Xhero App
          </div>
        </div>
        <div className="bg-gradient-to-l flex items-center justify-center from-[#342C25] via-[#342C25] to-[#342C2538] xl:w-[120%] xl:mt-[-100px] aspect-square xl:aspect-[707/778] w-full rounded-[20px] position-relative before:p-[1px]">
          <img
            src={items[activeIndex].img}
            alt="lakinh"
            className={`${
              showContent ? "opacity-100" : "opacity-0"
            } transition-opacity duration-700 xl:translate-x-6 z-[1] xl:block hidden`}
          />

          <div className="xl:hidden">
            <Swiper
              spaceBetween={30}
              initialSlide={0}
              // autoplay={{
              //   delay: 2500,
              //   disableOnInteraction: false,
              // }}
              slidesPerView={1}
              pagination={{
                el: ".swiper-pagination-introduce",
                clickable: true,
                renderBullet: renderBullet,
              }}
              onSlideChange={(swiper: any) => {
                if (isTabletOrLaptop) {
                  setActiveIndex(swiper.realIndex);
                }
              }}
              loop
              modules={[Autoplay, Pagination]}
              className="mySwiper block !xl:hidden mx-auto pb-10 relative"
            >
              {items.map((item, index) => {
                return (
                  <SwiperSlide key={index} className="!flex !w-full mx-auto">
                    <img
                      src={item.img}
                      alt="lakinh"
                      className={`${
                        showContent ? "opacity-100" : "opacity-0"
                      } transition-opacity duration-700 md:translate-x-6 z-[1] mx-auto mb-3`}
                    />
                  </SwiperSlide>
                );
              })}
              <div className="swiper-pagination-introduce xl:flex hidden -translate-x-1/2 absolute !left-1/2 !w-fit z-[2]"></div>
            </Swiper>
          </div>
        </div>
        <div className="hidden xl:flex items-center gap-6 absolute right-[5%] bottom-[5%]">
          <img
            src={
              activeIndex === 0
                ? IMAGES.buttonSlideDeactive
                : IMAGES.buttonSlide
            }
            alt="button"
            className="cursor-pointer"
            onClick={() => {
              if (activeIndex === 0) {
                return;
              }
              handlePrev(activeIndex);
            }}
          />
          <img
            src={
              activeIndex + 1 === items.length
                ? IMAGES.buttonSlideDeactive
                : IMAGES.buttonSlide
            }
            alt="button"
            className="rotate-180 cursor-pointer"
            onClick={() => {
              if (activeIndex + 1 === items.length) {
                return;
              }
              handleNext(activeIndex);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default SectionFeature1;
